import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { AlertMessageService } from '@sigepe/sigepe-template';
import { ConsultaRESTBaseService } from './consulta-restbase.service';

export interface FiltroTotalizadoresConsultaGerencial {
    nivel?: number;
    orgao?: number;
    upag?: number;
    uorg?: number;
    exercicio?: number;
    cpf?: number;
    nome?: string;
    matricula?: number;
}

export interface TotalizadoresConsultaGerencial {
    aguardandoHomologacao: number;
    exercicioSemProgramacao: number;
    feriasHomologadas: number;
}

export interface FiltroDetalhesExercicioSemProgramacao extends FiltroTotalizadoresConsultaGerencial {
    numeroPagina?: number;
    tamanhoPagina?: number;
}

export interface DetalheExercicioSemProgramacao {
    idFerias: number;
    codigoOrgao: number;
    siglaOrgaoExercicio?: string;
    descricaoOrgaoExercicio?: string;
    matricula: number;
    descricaoCargo?: string;
    matriculaNomeServidor: string;
    exercicioFerias: number;
    nomeChefiaUnidadeExercicio: string;
    codigoUorgChefiaUnidadeExercicio?: string;
    emailChefiaUnidadeExercicio: string;
    descricaoTipoFeriasEspecial?: string;
    acoes: string[];
}

export interface DetalhesExercicioSemProgramacaoResponse {
    lista: DetalheExercicioSemProgramacao[];
    totalRegistros: number;
    numeroPagina: number;
    totalPaginas: number;
    tamanhoPagina: number;
}

export interface ParcelaAguardandoHomologacao {
    id: number;
    idParcelaPai?: number;
    ordem: number;
    dataInicio: string;
    dataFim: string;
    quantidadeDias: number;
    situacao: string;
    adiantamentoSalarial: boolean;
    parcelasDesconto?: number;
    abonoPecuniario: boolean;
    adiantamentoDecimoTerceiro: boolean;
    justificativaAcumulo?: string;
    dataInterrupcao?: string;
    motivoLegal?: string;
    justificativaInterrupcao?: string;
    documentoLegal?: number;
    dataPublicacaoDocumentoLegal?: string;
}

export interface DetalheAguardandoHomologacao {
    idFerias: number;
    codigoOrgao: number;
    siglaOrgaoExercicio?: string;
    descricaoOrgaoExercicio?: string;
    matricula: number;
    descricaoCargo?: string;
    cpf: number;
    nomeServidor: string;
    matriculaNomeServidor: string;
    exercicioFerias: number;
    nomeChefiaUnidadeExercicio: string;
    codigoUorgChefiaUnidadeExercicio?: string;
    emailChefiaUnidadeExercicio: string;
    siglaRegimeJuridico: string;
    codigoSituacaoFuncional: number;
    saldoDias: number;
    situacaoExercicio: string;
    dataInicioPeriodoAquisitivo: string;
    dataFimPeriodoAquisitivo: string;
    dataInicioPeriodoProgramacao: string;
    dataFimPeriodoProgramacao: string;
    periodoAquisitivo: string;
    descricaoTipoFeriasEspecial?: string;
    parcelas: ParcelaAguardandoHomologacao[];
}

export interface DetalhesAguardandoHomologacaoResponse {
    lista: DetalheAguardandoHomologacao[];
    totalRegistros: number;
    numeroPagina: number;
    totalPaginas: number;
    tamanhoPagina: number;
}

export interface DetalheFeriasHomologadas {
    idFerias: number;
    codigoOrgao: number;
    siglaOrgaoExercicio?: string;
    descricaoOrgaoExercicio?: string;
    matricula: number;
    descricaoCargo?: string;
    cpf?: number;
    nomeServidor?: string;
    matriculaNomeServidor: string;
    exercicioFerias: number;
    nomeChefiaUnidadeExercicio?: string;
    codigoUorgChefiaUnidadeExercicio?: string;
    siglaRegimeJuridico?: string;
    codigoSituacaoFuncional?: number;
    saldoDias?: number;
    situacaoExercicio?: string;
    dataInicioPeriodoAquisitivo?: string;
    dataFimPeriodoAquisitivo?: string;
    dataInicioPeriodoProgramacao?: string;
    dataFimPeriodoProgramacao?: string;
    periodoAquisitivo?: string;
    descricaoTipoFeriasEspecial?: string;
    parcelas: ParcelaFeriasHomologada[];
}

export interface ParcelaFeriasHomologada {
    id?: number;
    idParcelaPai?: number;
    numeroParcela: string;
    dias: number;
    inicio: string;
    fim: string;
    situacao?: string;
}

export interface DetalhesFeriasHomologadasResponse {
    lista: DetalheFeriasHomologadas[];
    totalRegistros: number;
    numeroPagina: number;
    totalPaginas: number;
    tamanhoPagina: number;
}

@Injectable({
    providedIn: 'root'
})
export class ConsultaGerencialService extends ConsultaRESTBaseService {
    constructor(alertaMsgService: AlertMessageService, http: HttpClient) {
        super(alertaMsgService, http);
    }

    public obterTotalizadores(filtro: FiltroTotalizadoresConsultaGerencial): Observable<TotalizadoresConsultaGerencial> {
        return super.get('/consulta-gerencial/totalizadores', this.transformObjecttoParamArray(filtro));
    }

    public obterDetalhesExercicioSemProgramacao(filtro: FiltroDetalhesExercicioSemProgramacao): Observable<DetalhesExercicioSemProgramacaoResponse> {
        const params = this.transformObjecttoParamArray(filtro);
        console.log('[ConsultaGerencialService] obterDetalhesExercicioSemProgramacao', { filtro, params });
        return super.get('/consulta-gerencial/detalhes/exercicio-sem-programacao', params);
    }

    public obterDetalhesAguardandoHomologacao(filtro: FiltroDetalhesExercicioSemProgramacao): Observable<DetalhesAguardandoHomologacaoResponse> {
        return super.get('/consulta-gerencial/detalhes/aguardando-homologacao', this.transformObjecttoParamArray(filtro));
    }

    public obterDetalhesFeriasHomologadas(filtro: FiltroDetalhesExercicioSemProgramacao): Observable<DetalhesFeriasHomologadasResponse> {
        return super.get('/consulta-gerencial/detalhes/ferias-homologadas', this.transformObjecttoParamArray(filtro));
    }

    public exportarCsvAguardandoHomologacao(filtro: FiltroTotalizadoresConsultaGerencial): Observable<Blob> {
        return super.getBlob('/consulta-gerencial/exportacao/aguardando-homologacao/csv', this.transformObjecttoParamArray(filtro));
    }

    public exportarCsvExercicioSemProgramacao(filtro: FiltroTotalizadoresConsultaGerencial): Observable<Blob> {
        return super.getBlob('/consulta-gerencial/exportacao/exercicio-sem-programacao/csv', this.transformObjecttoParamArray(filtro));
    }

    public exportarCsvFeriasHomologadas(filtro: FiltroTotalizadoresConsultaGerencial): Observable<Blob> {
        return super.getBlob('/consulta-gerencial/exportacao/ferias-homologadas/csv', this.transformObjecttoParamArray(filtro));
    }
}
